import { PermissionResource, useRoleplay } from '@hub-la/fe-roleplay'
import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@hub-la/shadcn'
import { Copy, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type RowMemberActionsProps = {
  onCancelInvite: () => void
  onCopyInviteLink: () => void
}

export const RowInviteActions = ({ onCancelInvite, onCopyInviteLink }: RowMemberActionsProps) => {
  const { t } = useTranslation()
  const { hasPermission } = useRoleplay()

  return (
    <div className="flex items-center justify-end gap-2">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon" onClick={onCopyInviteLink}>
              <Copy className="h-4 w-4" />
            </Button>
          </TooltipTrigger>

          <TooltipContent>
            <p>{t('tabs.invites.rowActions.copyLinkTooltip')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {hasPermission(PermissionResource.PRODUCTS_MANAGE_MEMBERS) && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="ghost" size="icon" onClick={onCancelInvite}>
                <Trash2 className="h-4 w-4" />
              </Button>
            </TooltipTrigger>

            <TooltipContent>
              <p>{t('tabs.invites.rowActions.deleteInviteTooltip')}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  )
}
